:host {
    font-family: var(--uui-primary-font-family);
    font-size: var(--uui-small-font-size);
    line-height: var(--uui-sm-line-height);
    --uui-percentile-bar-legend-item-gap: var(--uui-x-large-padding);
}

.uui-percentile-bar-legend-container {
    display: flex;
    flex-direction: row;
    gap: var(--uui-percentile-bar-legend-item-gap);
}
  
.uui-percentile-bar-legend-item {
    display: flex;
    align-items: center;
    gap: 5px;
}
  
.uui-percentile-bar-legend-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
}

[data-mode="wrap"] {
    flex-wrap: wrap;
}